import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CssBasicsCourse = () => {
    const { t } = useTranslation();
    const { topic } = useParams();

    // Documentation for each CSS theme
    const content = {
        introduction: (
            <div>
                <h2>{t('cssBasicCourse.introduction')}</h2>
                <p>{t('cssBasicCourse.introductionContent')}</p>
                <h3>{t('cssBasicCourse.whatIsCss')}</h3>
                <p>{t('cssBasicCourse.whatIsCssDescription')}</p>
                <h3>{t('cssBasicCourse.basicSyntax')}</h3>
                <p>{t('cssBasicCourse.basicSyntaxDescription')}</p>
                <pre>
{`/* This is a comment */
body {
    background-color: lightblue;
}`}
                </pre>
            </div>
        ),
        selectors: (
            <div>
                <h2>{t('cssBasicCourse.selectors')}</h2>
                <p>{t('cssBasicCourse.selectorsContent')}</p>
                <h3>{t('cssBasicCourse.classAndId')}</h3>
                <p>{t('cssBasicCourse.classAndIdDescription')}</p>
                <h4>{t('cssBasicCourse.example')}</h4>
                <pre>
{`.className {
    color: red;
}

#idName {
    font-size: 20px;
}`}
                </pre>
            </div>
        ),
        boxModel: (
            <div>
                <h2>{t('cssBasicCourse.boxModel')}</h2>
                <p>{t('cssBasicCourse.boxModelContent')}</p>
                <h3>{t('cssBasicCourse.marginAndPadding')}</h3>
                <p>{t('cssBasicCourse.marginAndPaddingDescription')}</p>
                <h4>{t('cssBasicCourse.example')}</h4>
                <pre>
{`.box {
    width: 300px;
    height: 200px;
    margin: 20px;
    padding: 15px;
    border: 1px solid black;
}`}
                </pre>
            </div>
        ),
        flexbox: (
            <div>
                <h2>{t('cssBasicCourse.flexbox')}</h2>
                <p>{t('cssBasicCourse.flexboxContent')}</p>
                <h3>{t('cssBasicCourse.flexProperties')}</h3>
                <p>{t('cssBasicCourse.flexPropertiesDescription')}</p>
                <h4>{t('cssBasicCourse.example')}</h4>
                <pre>
{`.container {
    display: flex;
    justify-content: space-between;
}

.item {
    flex: 1;
    margin: 5px;
}`}
                </pre>
            </div>
        ),
        grid: (
            <div>
                <h2>{t('cssBasicCourse.grid')}</h2>
                <p>{t('cssBasicCourse.gridContent')}</p>
                <h3>{t('cssBasicCourse.gridProperties')}</h3>
                <p>{t('cssBasicCourse.gridPropertiesDescription')}</p>
                <h4>{t('cssBasicCourse.example')}</h4>
                <pre>
{`.grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
}

.grid-item {
    background-color: lightgrey;
    padding: 20px;
    text-align: center;
}`}
                </pre>
            </div>
        ),
        notFound: (
            <div>
                <h2>{t('cssBasicCourse.notFoundTitle')}</h2>
                <p>{t('cssBasicCourse.notFoundMessage')}</p>
            </div>
        ),
    };

    return (
        <div className="container mt-5">
            {content[topic] || content.notFound}
        </div>
    );
};

export default CssBasicsCourse;
